<template>
    <div class="content">
        <div class="main" v-for="(item, index) in list" :key="index">
            <a class="single" :href='"/activityDetail?id="+item.id'>
                <span class="dot"/>
                <span class="title">{{item.title}}
                    <br>{{item.create_time}}
                </span>
            </a>
            <!-- <div v-if="(index+1)<list.length" class="line"/> -->
        </div>
        
    </div>
</template>
<script>
export default {
    props:{
        list:{
            type:Array,
            default: () => [],
        }
    },
    methods: {
    },
}
</script>
<style lang="scss" scoped>
.content{
    width: 200px;
    background: #F0F0F0;
    padding: 0 15px;
}
.main{
    width:100%;
    position: relative;
    border-bottom: 1px dashed #CDCDCD;
    padding: 12px 0;
    box-sizing: border-box;
}
.single{
    cursor: pointer;
    .dot{
        width:4px;
        height:4px;
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        background: #235483;
        margin-right: 7px;
    }
    .title{
        font-size: 14px;
        color: #333333;
        letter-spacing: 0.45px;
        line-height: 22px;
        font-weight: 400;
        display: inline-block;
        vertical-align: top;
        width: calc(100% - 18px);
    }
}
.line{
    width:100%;
    border-top: 1px dashed #CDCDCD;
}
</style>
